exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".art[data-v-46d1883a]{position:absolute;top:0;left:0;bottom:0;right:0;background-size:100% auto;font-size:1.1em;text-align:right}.mpn[data-v-46d1883a]{font-size:1.2em;font-weight:700}.mpname[data-v-46d1883a]{font-size:1.1em}.price[data-v-46d1883a]{padding:.4em;display:inline-block}.price span[data-v-46d1883a]{font-size:1.4em;font-weight:700}.product-item[data-v-46d1883a]{border-bottom:1px dotted gray;padding-bottom:10px}.product-item[data-v-46d1883a]:last-child{border-bottom:none}.product-name[data-v-46d1883a]{font-weight:600;color:#337ab7;font-size:1.3em;line-height:100%}.product-info[data-v-46d1883a]{font-size:1.7em}.label-item[data-v-46d1883a]{font-weight:600;color:#667b82}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46d1883a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/ProductListItem.vue
// module id = 29
// module chunks = 0